export default __webpack_public_path__ + "static/media/i203jk.7bfcc1c3.webp";